import React from 'react';
import { blue } from '@mui/material/colors';
import { Stack, Typography } from '@mui/material';

import { FullReportResponse } from '../../types';
import { formatCurrency } from '../../../../utils';

interface Props {
  group: FullReportResponse['list'][number];
}

export const ReportListingAfterGroup = ({ group }: Props) => {
  return (
    <Stack direction="row" gap="0.5rem" alignItems="center">
      <Typography>Subtotals: </Typography>

      <Stack
        sx={{
          gap: '0.3rem',
          padding: '0.2rem 0.4rem',
          flexDirection: 'row',
          width: 'fit-content',
          borderRadius: '0.4rem',
          backgroundColor: blue[200],
        }}
      >
        <Typography>Invoice:</Typography>
        <Typography>{formatCurrency(group.meta.invoiceSubTotal, true)}</Typography>
      </Stack>

      <Stack
        sx={{
          gap: '0.3rem',
          padding: '0.2rem 0.4rem',
          flexDirection: 'row',
          width: 'fit-content',
          borderRadius: '0.4rem',
          backgroundColor: blue[200],
        }}
      >
        <Typography>Gross Profit:</Typography>
        <Typography>{formatCurrency(group.meta.grossProfitSubTotal, true)}</Typography>
      </Stack>

      <Stack
        sx={{
          gap: '0.3rem',
          padding: '0.2rem 0.4rem',
          flexDirection: 'row',
          width: 'fit-content',
          borderRadius: '0.4rem',
          backgroundColor: blue[200],
        }}
      >
        <Typography>Weighted Amount:</Typography>
        <Typography>{formatCurrency(group.meta.weightedAmountSubTotal, true)}</Typography>
      </Stack>
    </Stack>
  );
};
